import type { CustomContext, SaveCustomContextBody } from "@rebuild/shared";
import RestAPI from "../../utils/restAPI";

const ROUTE = "/rest/tools/customContext";

function requireResult<T>(result: T | null | undefined, action: string): T {
  if (result == null) {
    throw new Error(`Failed to ${action} custom context`);
  }
  return result;
}

export async function fetchCustomContexts(): Promise<CustomContext[]> {
  return requireResult(await RestAPI.fetchRebuildAPI(ROUTE, "GET", {}, "data", true, false), "fetch");
}

export async function saveCustomContext(body: SaveCustomContextBody): Promise<CustomContext> {
  if (body.id) {
    return requireResult(await RestAPI.fetchRebuildAPI(`${ROUTE}/${body.id}`, "PATCH", body, "data", true, false), "save");
  }
  return requireResult(await RestAPI.fetchRebuildAPI(ROUTE, "POST", body, "data", true, false), "save");
}

export async function deleteCustomContext(id: string): Promise<void> {
  requireResult(await RestAPI.fetchRebuildAPI(`${ROUTE}/${id}`, "DELETE", {}, "success", true, false), "delete");
}
